import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=486cd2db&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486cd2db')) {
      api.createRecord('486cd2db', component.options)
    } else {
      api.reload('486cd2db', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=486cd2db&", function () {
      api.rerender('486cd2db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/password/edit.vue"
export default component.exports